import { createEl } from "@/client/utils/createEl";
import { slider, type SliderVariants } from "./slider.css";

export interface SliderOptions extends NonNullable<SliderVariants> {
    min?: number;
    max?: number;
    step?: number;
    value?: number;
    disabled?: boolean;
    onChange?: (value: number, event: Event) => void;
    onInput?: (value: number, event: Event) => void;
    ariaLabel?: string;
}

export const createSliderComponent = (
    options: SliderOptions,
    init?: (el: HTMLInputElement) => void,
): HTMLInputElement => {
    return createEl("input", slider({ theme: options.theme }), [], (el) => {
        el.type = "range";
        el.min = String(options.min ?? 0);
        el.max = String(options.max ?? 100);
        el.step = String(options.step ?? 1);
        el.value = String(options.value ?? 50);
        el.disabled = options.disabled ?? false;
        if (options.ariaLabel !== undefined) {
            el.setAttribute("aria-label", options.ariaLabel);
        }
        if (options.onChange !== undefined) {
            const onChange = options.onChange;
            el.addEventListener("change", (event) => {
                const value = parseFloat(el.value);
                if (Number.isFinite(value)) {
                    onChange(value, event);
                }
            });
        }
        if (options.onInput !== undefined) {
            const onInput = options.onInput;
            el.addEventListener("input", (event) => {
                const value = parseFloat(el.value);
                if (Number.isFinite(value)) {
                    onInput(value, event);
                }
            });
        }
        init?.(el);
    });
};
